<template>
  <div></div>
</template>
<script>
import api from "@/requset/api";
export default {
  name: "APP",
  data() {
    return {};
  },

  methods: {
    onlodes() {
      console.log("中间页");
      console.log(this.$route);
      api
        .FaceID({
          order_no: this.$route.query.orderNo,
        })
        .then((res) => {
          console.log(res.data.error_code);
        })
        .catch((err) => {});
      let params = {
        // ...
      };
    },
  },

  created() {
    this.onlodes();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
</style>
